<template>
  <Card class="platform-notice" title="平台公告">
    <ul>
      <template v-for="(cont, index) in notice">
        <li class="ellipsis" @click="$openHome(`${cont.url}?colCode=sc_code`, '通知公告', 1, 1)" :key="index">
          {{ cont.title }}
        </li>
      </template>
    </ul>
  </Card>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import Card from "@/components/Card";

export default {
  components: {
    Card,
  },

  data() {
    return {
      notice: [],
    };
  },

  mounted() {
    // 通知公告
    this.$store
      .dispatch("orderHome/index/getQueryNotice", {
        platformType: "SC",
      })
      .then((data) => {
        const list = data ? (data.length > 6 ? data.slice(0, 6) : data) : [];
        this.notice = list;
      });
  },
};
</script>
